import { render, staticRenderFns } from "./FuelResourcesLayout.vue?vue&type=template&id=42318e82&"
import script from "./FuelResourcesLayout.vue?vue&type=script&lang=js&"
export * from "./FuelResourcesLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42318e82')) {
      api.createRecord('42318e82', component.options)
    } else {
      api.reload('42318e82', component.options)
    }
    module.hot.accept("./FuelResourcesLayout.vue?vue&type=template&id=42318e82&", function () {
      api.rerender('42318e82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/main-column/FuelResourcesLayout.vue"
export default component.exports